import { MODE_CONTROL_CAMERA_CONTROL } from '../../components/LiveStream/constants';
import {
  ADD_USER_INTERACTION,
  REMOVE_USER_INTERACTION,
  SET_CLIP_DATA,
  SET_FULL_SCREEN,
  SET_IS_CREATING_UGC,
  SET_IS_PUBLISHING_UGC,
  SET_SHOW_VIV_TRANSCRIPT,
  SET_SNAPSHOT_DATA,
  SET_VIV_SUPPORTS_TRANSCRIPT,
  SHOW_SNAPSHOT_SHARE_POPUP,
  TOGGLE_IS_BROADCASTING,
  TOGGLE_IS_STREAM_PLAYING,
  TOGGLE_STREAM_AREA_WARNING_MSG,
  UPDATE_VIEWERS,
} from '../types';

const initialState = {
  userInteractions: [],
  interactionState: {
    showSnapshotShare: true,
    isStreamPlaying: false,
    isBroadcasting: false,
    mode: MODE_CONTROL_CAMERA_CONTROL,
    showHostOnlyWarningMsg: false,
  },
  viewers: 0,
  fullScreen: false,
  snapshot: {},
  clip: {},
  showVivTranscript: true,
  vivSupportsTranscript: false,
  /** True while requesting raw UGC media (snapshot/clip) before the draft UI is shown. */
  isCreatingUGC: false,
  /** True after the user clicks save/publish on a snapshot or clip draft. */
  isPublishingUGC: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ADD_USER_INTERACTION: {
      return {
        ...state,
        userInteractions: [...state.userInteractions, payload],
      };
    }
    case UPDATE_VIEWERS: {
      const { viewers } = payload;
      return {
        ...state,
        viewers,
      };
    }

    case REMOVE_USER_INTERACTION: {
      const { interactionId: id } = payload;

      return {
        ...state,
        userInteractions: state.userInteractions.filter((item) => item.interactionId !== id),
      };
    }

    case TOGGLE_STREAM_AREA_WARNING_MSG: {
      return {
        ...state,
        interactionState: {
          ...state.interactionState,
          showStreamWarningMsg: payload,
        },
      };
    }

    case TOGGLE_IS_STREAM_PLAYING: {
      return {
        ...state,
        interactionState: {
          ...state.interactionState,
          isStreamPlaying: !state.interactionState.isStreamPlaying,
        },
      };
    }
    case TOGGLE_IS_BROADCASTING: {
      return {
        ...state,
        interactionState: {
          ...state.interactionState,
          isBroadcasting: !state.interactionState.isBroadcasting,
        },
      };
    }
    case SHOW_SNAPSHOT_SHARE_POPUP: {
      const { show } = payload;
      return {
        ...state,
        interactionState: {
          ...state.interactionState,
          showSnapshotShare: show,
        },
      };
    }

    case SET_FULL_SCREEN: {
      const { isActive } = payload;
      return { ...state, fullScreen: isActive };
    }

    case SET_SNAPSHOT_DATA: {
      const { data } = payload;
      return { ...state, snapshot: data, isPublishingUGC: false };
    }

    case SET_CLIP_DATA: {
      const { data } = payload;
      return { ...state, clip: data, isPublishingUGC: false };
    }

    case SET_VIV_SUPPORTS_TRANSCRIPT: {
      return {
        ...state,
        vivSupportsTranscript: payload,
      };
    }

    case SET_SHOW_VIV_TRANSCRIPT: {
      return {
        ...state,
        showVivTranscript: payload,
      };
    }

    case SET_IS_CREATING_UGC: {
      const { isCreating } = payload;
      return {
        ...state,
        isCreatingUGC: isCreating,
      };
    }

    case SET_IS_PUBLISHING_UGC: {
      const { isPublishing } = payload;
      return {
        ...state,
        isPublishingUGC: isPublishing,
      };
    }

    default: {
      return state;
    }
  }
};
